module.exports = __webpack_public_path__ + "static/media/error.c6d7063e.mp3";